import { render, staticRenderFns } from "./text-field.vue?vue&type=template&id=5bd02538&scoped=true"
import script from "./text-field.vue?vue&type=script&lang=js"
export * from "./text-field.vue?vue&type=script&lang=js"
import style0 from "./text-field.vue?vue&type=style&index=0&id=5bd02538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd02538",
  null
  
)

export default component.exports